import React, { useState } from "react";
import CMCLogo from "./assets/Logotype.png";
import BackIcon from "./assets/back-icon.png";
import PersonalDetails from "./screens/PersonalDetails";
import AdditionalPersonalDetails from "./screens/AdditionalPersonalDetails";
import AddressDetails from "./screens/AddressDetails";
import PrimaryButton from "./components/Submit";
import EmploymentDetails from "./screens/EmploymentDetails";
import FinancialBackground from "./screens/FinancialBackground";
import KnowledgeAndExperience from "./screens/KnowledgeAndExperience";

const allScreens = [
  "personalDetails",
  "additionalPersonalDetails",
  "addressDetails",
  "employmentDetails",
  "financialBackground",
  "knowledgeAndExperience",
] as const;

const screenMap: {
  [key in (typeof allScreens)[number]]: React.FC<{
    onNext: () => void;
    currentIndex: number;
    totalSteps: number;
  }>;
} = {
  personalDetails: PersonalDetails,
  additionalPersonalDetails: AdditionalPersonalDetails,
  financialBackground: FinancialBackground,
  addressDetails: AddressDetails,
  employmentDetails: EmploymentDetails,
  knowledgeAndExperience: KnowledgeAndExperience,
};

function WithoutPega() {
  const [currentScreen, setCurrentScreen] =
    useState<(typeof allScreens)[number]>("personalDetails");

  const onNext = () => {
    const currentIndex = allScreens.indexOf(currentScreen);
    const nextIndex = (currentIndex + 1) % allScreens.length;
    setCurrentScreen(allScreens[nextIndex]);
  };

  const showBackButton = currentScreen !== "personalDetails";

  const currentIndex = allScreens.indexOf(currentScreen) + 1;

  const totalSteps = allScreens.length;

  return (
    <div className="container">
      <header className="header">
        {showBackButton && (
          <PrimaryButton
            loading={false}
            className="back-button"
            onClick={() => {
              const currentIndex = allScreens.indexOf(currentScreen);
              const prevIndex =
                (currentIndex - 1 + allScreens.length) % allScreens.length;
              setCurrentScreen(allScreens[prevIndex]);
            }}
          >
            <img src={BackIcon} alt="Back" width={16} />
          </PrimaryButton>
        )}
        <div className="container">
          <div className="logo">
            <img src={CMCLogo} alt="CMC Logo" />
          </div>
        </div>
      </header>
      <main className="main-content">
        {React.createElement(screenMap[currentScreen], {
          onNext,
          currentIndex,
          totalSteps,
        })}
      </main>
    </div>
  );
}

export default WithoutPega;
